$(document).on ('change', '.machine-model-type-selector', () => {
  model_type = $('.machine-model-type-selector').find('option:selected').val()
  
  if (model_type == 'electrolux_dryer') {
    $('.max-duration-input').prop('disabled', false)
  } else {
    $('.max-duration-input').prop('disabled', true)
    $('.max-duration-input').val(0)
  }
})
